module.exports = __webpack_public_path__ + "img/UI_RMYX_biaoqian_01_1_c5575f8c8.png";